// extracted by mini-css-extract-plugin
export var Navigation = "Navigation-module--Navigation--9ea13";
export var isCurrent = "Navigation-module--isCurrent--ef289";
export var search = "Navigation-module--search--ddbd4";